// extracted by mini-css-extract-plugin
export default {"header":"HeaderAuth_header__8xUpd","logo":"HeaderAuth_logo__J5IAV"};